import { useEffect, useState } from "react";
import { Typography } from "@mui/material";

export default function CountdownTimer({ expiration }: { expiration: string }) {
  const [timeLeft, setTimeLeft] = useState<number>(() => {
    const exp = new Date(expiration).getTime();
    return exp - Date.now();
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const diff = new Date(expiration).getTime() - Date.now();
      setTimeLeft(diff > 0 ? diff : 0);
    }, 1000); // update every 1 sec

    return () => clearInterval(interval);
  }, [expiration]);

  const seconds = Math.floor((timeLeft / 1000) % 60);
  const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
  const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);

  return (
    <div>
      {timeLeft <= 0 ? (
        <
        >
            Expired
        </>
      ) : (
        <
        >
          {hours}h {minutes}m {seconds}s
        </>
      )}
    </div>
  );
}
